import { getCompatibleVersions } from "baseline-browser-mapping";

type Utils = {
  browser: string;
  version: string;
};

type BrowserCompatibility = {
  isCompatible: boolean | undefined;
  currentBrowser: Utils | null;
  currentBrowserLastCompatibleVersion: Utils | undefined;
  message?: string;
  messageTitle?: string;
};

export function getBrowserCompatibility(): BrowserCompatibility {
  const currentBrowser = detectBrowser();
  const compatibleVersions = getCompatibleVersions();

  const currentBrowserLastCompatibleVersion = compatibleVersions.find(
    (cv) => cv.browser === currentBrowser?.browser
  );

  if (!currentBrowser || !currentBrowserLastCompatibleVersion) {
    return {
      isCompatible: undefined,
      currentBrowser: null,
      currentBrowserLastCompatibleVersion: undefined,
      message:
        "Nous n'avons pas  réussi à détecter la version de votre navigateur. Nous ne pouvons assurer un fonctionnement optimal de l'application",
    };
  }

  const isCompatible =
    Number(currentBrowser.version) >=
    Number(currentBrowserLastCompatibleVersion.version);

  return {
    isCompatible,
    currentBrowser,
    currentBrowserLastCompatibleVersion,
    messageTitle: isCompatible
      ? undefined
      : "Votre navigateur n'est pas pris en charge",
    message: isCompatible
      ? undefined
      : `Pour une expérience optimale, veuillez le mettre à jour vers la version ${currentBrowserLastCompatibleVersion.version} au minimum.`,
  };
}

function detectBrowser(): Utils | null {
  if (typeof navigator === "undefined") return null;
  if (!navigator) return null;
  const ua = navigator.userAgent;
  const isMobile = /Mobi|Android/i.test(ua);
  let match;

  // Chrome (desktop et Android)
  if ((match = ua.match(/Chrome\/(\d+)/)) && !ua.match(/Edg/)) {
    return {
      browser: isMobile ? "chrome_android" : "chrome",
      version: match[1],
    };
  }

  // Edge
  if ((match = ua.match(/Edg\/(\d+)/))) {
    return { browser: "edge", version: match[1] };
  }

  // Firefox (desktop et Android)
  if ((match = ua.match(/Firefox\/(\d+)/))) {
    return {
      browser: isMobile ? "firefox_android" : "firefox",
      version: match[1],
    };
  }

  // Safari (iOS et desktop)
  if ((match = ua.match(/Version\/([\d.]+).*Safari/))) {
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    return {
      browser: isIOS ? "safari_ios" : "safari",
      version: match[1],
    };
  }

  return null;
}
